import { render, staticRenderFns } from "./NewStuff.vue?vue&type=template&id=6bfad6a0&"
import script from "./NewStuff.vue?vue&type=script&lang=js&"
export * from "./NewStuff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports